/* Raptor Recommendations — client renderer for sections/raptor-recs.liquid.
   Fetches products (native recommendations API on product pages, collection
   JSON otherwise), filters to in-stock items not already in the cart,
   shuffles per visit, renders carousel cards, and adds via /cart/add.js. */
(function () {
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // "$1,007.95" (spec v2.17 cards); falls back to the plain form
  function money(cents) {
    var v = cents / 100;
    try { return '$' + v.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '$' + v.toFixed(2); }
  }
  // Two card rows on one product page (Customers also viewed, You may also
  // like) never repeat a product: whichever renders first keeps it.
  var SHOWN = window.__rrRecsShown || (window.__rrRecsShown = {});

  // Measurement (raptor-recs step 1): which rows are seen, clicked and added,
  // smart ranking vs Shopify's lists. Product ids, row and position only: no
  // visitor, session or customer data. Beacons wait for the first real scroll,
  // tap or key, so headless crawlers that never interact are not counted.
  // 20% of visitors keep Shopify's lists (control) so the difference is measurable.
  var AB = (function () {
    var key = 'rr-ab-v1', v = null;
    try { v = localStorage.getItem(key); } catch (e) { /* storage blocked */ }
    if (v !== 'smart' && v !== 'control') {
      v = Math.random() < 0.2 ? 'control' : 'smart';
      try { localStorage.setItem(key, v); } catch (e) { /* per-page bucket then */ }
    }
    return v;
  })();
  var evQueue = [], evEngaged = false, evTimer = null;
  function evSend(useBeacon) {
    evTimer = null;
    if (!evEngaged || !evQueue.length) return;
    var body = JSON.stringify({ v: 1, ab: AB, ev: evQueue.splice(0, 40) });
    var url = '/apps/rr-recs/event';
    try {
      if (useBeacon && navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
      else fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
    } catch (e) { /* measurement never breaks the page */ }
    if (evQueue.length) evSchedule();
  }
  function evSchedule() { if (!evTimer) evTimer = setTimeout(function () { evSend(false); }, 1500); }
  function rrEvent(e) { if (evQueue.length < 200) evQueue.push(e); if (evEngaged) evSchedule(); }
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(function (t) {
    window.addEventListener(t, function () { if (!evEngaged) { evEngaged = true; evSchedule(); } }, { passive: true, once: true });
  });
  window.addEventListener('pagehide', function () { evSend(true); });

  function normalize(p) {
    var variant = null;
    for (var i = 0; i < (p.variants || []).length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    if (!variant || p.available === false) return null;
    var img = p.featured_image || (p.images && p.images[0]) || null;
    if (img && typeof img === 'object') img = img.src || null;
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      productType: p.product_type || p.type || '',
      vendor: p.vendor || '',
      url: p.url || ('/products/' + p.handle),
      image: img,
      variantId: variant.id,
      price: typeof variant.price === 'number' ? variant.price : Math.round(parseFloat(variant.price) * 100),
      compareAt: (function () {
        // Penny-off compare-at feed artifacts: mirror the trivial-sale gate
        // in product.liquid / z__jsProduct.js (>= $1 AND floored >= 1% saved).
        if (!variant.compare_at_price) return null;
        var gvCap = typeof variant.compare_at_price === 'number' ? variant.compare_at_price : Math.round(parseFloat(variant.compare_at_price) * 100);
        var gvPrice = typeof variant.price === 'number' ? variant.price : Math.round(parseFloat(variant.price) * 100);
        var gvDelta = gvCap - gvPrice;
        if (gvDelta < 100 || Math.floor((gvDelta * 100) / gvCap) < 1) return null;
        return gvCap;
      })()
    };
  }

  function squareImage(url) {
    if (!url) return null;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=480';
  }

  function fetchJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // One product's review average and count (templates/product.rr-rating-endpoint.liquid),
  // kept in localStorage for 24 hours; resolves null on any failure.
  var RATE_TTL = 24 * 3600 * 1000;
  var rateMem = {};
  function rrRating(handle) {
    if (!handle) return Promise.resolve(null);
    if (rateMem[handle]) return rateMem[handle];
    var key = 'rr-rate:' + handle;
    try {
      var saved = JSON.parse(window.localStorage.getItem(key) || 'null');
      if (saved && saved.t > Date.now() - RATE_TTL) return (rateMem[handle] = Promise.resolve(saved.d));
    } catch (e) { /* storage blocked */ }
    rateMem[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=rr-rating-endpoint', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        var d = null;
        try { d = t ? JSON.parse(t) : null; } catch (e) { d = null; }
        if (d) { try { window.localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: { r: +d.r || 0, n: +d.n || 0 } })); } catch (e) {} }
        return d ? { r: +d.r || 0, n: +d.n || 0 } : null;
      })
      .catch(function () { return null; });
    return rateMem[handle];
  }

  // raptor-recs service (Fly.io, via the /apps/rr-recs app proxy): a ranked list of
  // same-vehicle add-ons plus `avoid` / `avoid_types`, products and product types it rejected
  // for this one (wrong vehicle, bolt pattern or lug count, doesn't fit, unrelated).
  // Resolves { list, avoid, avoidTypes }, or null
  // (caller uses Shopify's lists alone) when the proxy is missing, slow or still computing.
  function smartSource(path) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 2500);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch('/apps/rr-recs/' + path, { headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(timer);
        if (!d || d.status !== 'ready') return null;
        // Add-ons first; on the product page (`more`, pdp only) other parts for the same car follow them.
        var picks = (d.goes || []).map(function (g) { return { h: g.handle, src: 'smart' }; })
          .concat((d.more || []).map(function (g) { return { h: g.handle, src: 'more' }; }))
          .slice(0, 12);
        if (!picks.length) return null;
        return Promise.all(picks.map(function (g) {
          return fetchJSON(root + 'products/' + encodeURIComponent(g.h) + '.js').then(function (p) {
            if (p) p.__rrSrc = g.src;
            return p;
          });
        })).then(function (list) {
          list = list.filter(Boolean);
          return list.length ? { list: list, avoid: d.avoid || [], avoidTypes: d.avoid_types || [],
            skipFamilies: d.skip_families || [] } : null;
        });
      })
      .catch(function () { clearTimeout(timer); return null; });
  }

  function fetchCollections(handles, perCollection) {
    var jobs = handles.filter(Boolean).map(function (h) {
      return fetchJSON('/collections/' + encodeURIComponent(h.trim()) + '/products.json?limit=' + perCollection)
        .then(function (d) { return (d && d.products) || []; });
    });
    return Promise.all(jobs).then(function (lists) {
      return [].concat.apply([], lists);
    });
  }

  /* v7.1 (owner, 3 Oct 2026): "Customers also viewed" strip under the product
     form (snippets/rr-cav-strip.liquid). The product page's merged row hands it
     its first picks; one shows at a time and slides on every few seconds.
     Rotation waits for the shopper's first scroll, tap or key (a rotating
     element painted before any input is a new "largest paint" candidate each
     time) and for the strip to be on screen; it pauses on hover, focus and
     touch, follows a swipe, and stays still under reduced motion. */
  function stripGone(strip) {
    if (!strip) return;
    strip.classList.remove('is-pending');
    strip.classList.add('is-empty');
  }
  function buildStrip(strip, list, ev) {
    var track = strip.querySelector('[data-rr-strip-track]');
    var dotsEl = strip.querySelector('[data-rr-strip-dots]');
    var bar = strip.querySelector('.rr-cav__bar i');
    if (!track) return;
    var n = list.length;
    list.forEach(function (item, pos) {
      var it = document.createElement('div');
      it.className = 'rr-cav__it';
      it.setAttribute('role', 'group');
      it.setAttribute('aria-roledescription', 'slide');
      it.setAttribute('aria-label', (pos + 1) + ' of ' + n);
      var media = document.createElement('a');
      media.className = 'rr-cav__media';
      media.href = item.url;
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.className = 'rr-cav__img';
      img.loading = 'lazy';
      img.alt = '';
      img.width = 56; img.height = 56;
      img.src = squareImage(item.image) || '';
      media.appendChild(img);
      var info = document.createElement('div');
      info.className = 'rr-cav__info';
      var title = document.createElement('a');
      title.className = 'rr-cav__t';
      title.href = item.url;
      title.textContent = item.title;
      var onSale = !!(item.compareAt && item.compareAt > item.price);
      var price = document.createElement('div');
      price.className = 'rr-cav__p' + (onSale ? ' is-sale' : '');
      price.textContent = money(item.price);
      if (onSale) {
        var was = document.createElement('s');
        was.textContent = money(item.compareAt);
        price.appendChild(was);
      }
      info.appendChild(title); info.appendChild(price);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rr-cav__btn rr-button--primary';   /* the brand primary button: lift, chevrons, press, "Added" flip (4 Oct 2026) */
      btn.setAttribute('aria-label', 'Add ' + item.title + ' to cart');
      var label = document.createElement('span');
      label.className = 'text';
      label.textContent = 'Add';
      btn.appendChild(label);
      [media, title].forEach(function (el) { el.addEventListener('click', function () { ev('click', item, pos); }); });
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.classList.add('is-loading');   /* the claw loader in place of the label, so the width never jumps */
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.variantId, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          ev('add', item, pos);
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          label.textContent = 'Add';
          try {
            document.dispatchEvent(new CustomEvent('gv:cart:added', { detail: { button: btn } }));
          } catch (e) { label.textContent = 'Added ✓'; }
          try { document.dispatchEvent(new CustomEvent('rr:recs:added')); } catch (e) { /* old browsers */ }
        }).catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          label.textContent = 'Add';
        });
      });
      it.appendChild(media); it.appendChild(info); it.appendChild(btn);
      track.appendChild(it);
    });
    strip.classList.remove('is-pending');
    if (n < 2) { strip.classList.add('is-single'); return; }

    var idx = 0, timer = null, anim = null, held = false, seen = false, engaged = false;
    var dwell = parseInt(strip.dataset.dwell, 10) || 3500;
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var dots = [];
    for (var d = 0; d < n; d++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rr-cav__dot';
      dot.setAttribute('aria-label', 'Show item ' + (d + 1) + ' of ' + n);
      (function (k) { dot.addEventListener('click', function () { go(k); }); })(d);
      if (dotsEl) dotsEl.appendChild(dot);
      dots.push(dot);
    }
    /* v7.1 motion review D3 (owner, 4 Oct: keep rotating, tuned): a pause
       control beside the dots; paused stays paused until pressed again */
    var paused = false;
    if (!reduced && dotsEl) {
      /* the announcement bar's own glyphs (sections/announcement-bar.liquid), so the two controls match */
      var PAUSE_SVG = '<span aria-hidden="true">\u275A\u275A</span>';
      var PLAY_SVG = '<span aria-hidden="true">\u25B6\uFE0E</span>';
      var pauseBtn = document.createElement('button');
      pauseBtn.type = 'button';
      pauseBtn.className = 'rr-cav__pause';
      var setPause = function () {
        pauseBtn.innerHTML = paused ? PLAY_SVG : PAUSE_SVG;
        pauseBtn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
        strip.classList.toggle('is-paused', paused);
      };
      setPause();
      pauseBtn.addEventListener('click', function () { paused = !paused; setPause(); schedule(); });
      dotsEl.appendChild(pauseBtn);
    }
    function running() { return !reduced && !held && !paused && seen && engaged && !document.hidden; }
    function schedule() {
      clearTimeout(timer);
      if (anim) { try { anim.cancel(); } catch (e) { /* noop */ } anim = null; }
      if (!running()) return;
      if (bar && bar.animate) anim = bar.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: dwell, easing: 'linear' });
      timer = setTimeout(function () { go(idx + 1); }, dwell);
    }
    function go(k) {
      idx = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * idx) + '%)';
      dots.forEach(function (dt, j) {
        dt.classList.toggle('is-on', j === idx);
        dt.setAttribute('aria-current', j === idx ? 'true' : 'false');
      });
      [].forEach.call(track.children, function (slide, j) {
        var on = j === idx;
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        [].forEach.call(slide.querySelectorAll('.rr-cav__t, .rr-cav__btn'), function (f) {
          if (on) f.removeAttribute('tabindex'); else f.setAttribute('tabindex', '-1');
        });
      });
      schedule();
    }
    function hold(h) {
      held = h;
      if (h) { clearTimeout(timer); if (anim) { try { anim.pause(); } catch (e) { /* noop */ } } } else schedule();
    }
    var lastTouch = 0, tx = null, ty = null;
    strip.addEventListener('mouseenter', function () { if (Date.now() - lastTouch > 800) hold(true); });
    strip.addEventListener('mouseleave', function () { hold(false); });
    strip.addEventListener('focusin', function () { hold(true); });
    strip.addEventListener('focusout', function (e) { if (!e.relatedTarget || !strip.contains(e.relatedTarget)) hold(false); });
    strip.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      if (t) { tx = t.clientX; ty = t.clientY; }
      hold(true);
    }, { passive: true });
    strip.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      lastTouch = Date.now();
      if (t && tx !== null) {
        var dx = t.clientX - tx, dy = t.clientY - ty;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.2) { held = false; go(idx + (dx < 0 ? 1 : -1)); tx = ty = null; return; }
      }
      tx = ty = null;
      hold(false);
    }, { passive: true });
    strip.addEventListener('touchcancel', function () { tx = ty = null; lastTouch = Date.now(); hold(false); }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    var START = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'wheel'];
    function engage() {
      engaged = true;
      START.forEach(function (t) { window.removeEventListener(t, engage, true); });
      schedule();
    }
    START.forEach(function (t) { window.addEventListener(t, engage, { capture: true, passive: true }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        seen = entries.some(function (en) { return en.isIntersecting; });
        schedule();
      }, { threshold: 0.5 }).observe(strip);
    } else { seen = true; }
    go(0);
  }

  function init(root) {
    var track = root.querySelector('[data-rr-track]');
    if (!track) return;
    var mode = root.dataset.mode || 'auto';
    var layout = root.dataset.layout || 'carousel';
    var intent = root.dataset.intent || 'related';
    var handles = (root.dataset.collections || '').split(',').filter(Boolean);
    var maxItems = parseInt(root.dataset.maxItems, 10) || 8;
    var productId = root.dataset.productId;
    var showStars = root.dataset.showStars === 'true';
    var showQty = root.dataset.showQty === 'true';

    // Cart first: it powers both the exclude-list and, on the cart page,
    // the recommendation seed (first item) when no product context exists.
    fetchJSON('/cart.js').then(function (cart) {
      var cartItems = (cart && cart.items) || [];
      var seedIds = [];
      if (productId) seedIds.push(String(productId));
      if (!seedIds.length && mode === 'auto') {
        cartItems.slice(0, 3).forEach(function (it) {
          if (seedIds.indexOf(String(it.product_id)) === -1) seedIds.push(String(it.product_id));
        });
      }
      var seedId = seedIds[0] || null;

      var sourcePromise;
      var merge = root.dataset.merge === 'true';
      var smart = root.dataset.smart === 'true';
      var smartUsed = false;
      var smartPath = null;
      if (smart && merge && seedId) smartPath = 'pdp?product_id=' + seedId;
      else if (smart && mode === 'auto' && seedIds.length && !productId) smartPath = 'cart?ids=' + seedIds.join(',');
      // Rows eligible for smart ranking are measured; the control bucket keeps Shopify's lists.
      var evRow = smartPath ? (merge ? 'pdp' : 'cart') : null;
      var evSeed = merge ? String(seedId) : String(seedIds[0] || '');
      if (smartPath && AB === 'control') smartPath = null;
      if (evRow === 'pdp') rrEvent({ k: 'pv', p: evSeed });
      if (merge && seedId) {
        // Spec v2.18 6F.10: ONE row on product pages. "Customers also viewed"
        // (Shopify Search & Discovery complementary products) first, then
        // "You may also like" (Shopify's related-products algorithm); order
        // kept, duplicates, this product and cart items dropped below.
        var mbase = '/recommendations/products.json?product_id=' + seedId + '&limit=12';
        sourcePromise = Promise.all([
          fetchJSON(mbase + '&intent=complementary'),
          fetchJSON(mbase + '&intent=related')
        ]).then(function (res) {
          var a = (res[0] && res[0].products) || [];
          var b = (res[1] && res[1].products) || [];
          a.forEach(function (p) { if (p) p.__rrSrc = 'viewed'; });
          return a.concat(b);
        });
      } else if (mode === 'auto' && seedIds.length) {
        sourcePromise = Promise.all(seedIds.map(function (sid) {
          var base = '/recommendations/products.json?product_id=' + sid + '&limit=' + Math.max(12, maxItems);
          return fetchJSON(base + '&intent=' + intent)
            .then(function (d) {
              var got = (d && d.products) || [];
              if (got.length >= 2 || intent === 'related') return got;
              return fetchJSON(base + '&intent=related').then(function (d2) {
                return got.concat((d2 && d2.products) || []);
              });
            });
        })).then(function (lists) {
          var recs = [].concat.apply([], lists);
          if (recs.length >= 4 || !handles.length) return recs;
          return fetchCollections(handles, 30).then(function (extra) { return recs.concat(extra); });
        });
      } else {
        sourcePromise = fetchCollections(handles, 30);
      }

      if (smartPath) {
        // Smart picks first (as many as the service has), then Shopify's own list fills
        // the row, minus anything the service rejected for this product.
        var fallback = sourcePromise;
        sourcePromise = Promise.all([smartSource(smartPath), fallback]).then(function (res) {
          var smartRes = res[0], rest = res[1] || [];
          if (!smartRes) return rest;
          var skip = {}, skipType = {};
          smartRes.avoid.concat(smartRes.list.map(function (p) { return p.id; })).forEach(function (id) { skip[String(id)] = true; });
          smartRes.avoidTypes.forEach(function (t) { skipType[t] = true; });
          // cart only: Shopify's fill never adds more of what's already in the cart (another wheel)
          var skipFam = {};
          smartRes.skipFamilies.forEach(function (f) { skipFam[f] = true; });
          var fam = function (t) { return (t || '').split(' - ')[0].trim().toLowerCase(); };
          rest = rest.filter(function (p) {
            var t = p && (p.product_type || p.type || '');
            return p && !skip[String(p.id)] && !skipType[t] && !skipFam[fam(t)];
          });
          rest.forEach(function (p) { p.__rrSrc = 'shopify'; });
          smartUsed = true;
          return smartRes.list.concat(rest);
        });
      }

      sourcePromise.then(function (products) {
        products = products || [];
      var inCart = {};
      ((cart && cart.items) || []).forEach(function (it) { inCart[it.product_id] = true; });

      // Never recommend service/utility products.
      var EXCLUDED_TYPES = /shipping protection|gift card|insurance|route package/i;

      var seedTypes = {};
      var seedVendors = {};
      if (root.dataset.productType) seedTypes[root.dataset.productType] = true;
      if (root.dataset.productVendor) seedVendors[root.dataset.productVendor] = true;
      cartItems.forEach(function (it) {
        if (it.product_type) seedTypes[it.product_type] = true;
        if (it.vendor) seedVendors[it.vendor] = true;
      });

      var seen = {};
      var pool = [];
      products.forEach(function (p) {
        if (!p || seen[p.id] || inCart[p.id]) return;
        if (String(p.id) === String(seedId || productId)) return;
        seen[p.id] = true;
        var n = normalize(p);
        if (!n) return;
        if (EXCLUDED_TYPES.test(n.productType) || EXCLUDED_TYPES.test(n.title)) return;
        n.src = p.__rrSrc === 'smart' || p.__rrSrc === 'more' ? p.__rrSrc : 'shopify';
        pool.push(n);
      });

      // Relevance tiers: same product type as anything in context, then same
      // vendor, then the rest. Tier 3 only BACKFILLS when relevant matches
      // are scarce (fewer than MIN_RELEVANT) — otherwise oddballs are cut,
      // not just sunk.
      var MIN_RELEVANT = 4;
      var t1 = [], t2 = [], t3 = [];
      pool.forEach(function (n) {
        if (n.productType && seedTypes[n.productType]) t1.push(n);
        else if (n.vendor && seedVendors[n.vendor]) t2.push(n);
        else t3.push(n);
      });
      // Smart rows arrive ranked and already vehicle-filtered: keep their order.
      var items = (merge || smartUsed) ? pool.slice() : shuffle(t1).concat(shuffle(t2));
      // data-strict (spec v2.17: Customers also viewed as a card row) keeps the
      // compact rows' relevance rule in the card layout
      if (layout === 'compact' || root.dataset.strict === 'true') {
        // Prime placement: relevant matches only, hide entirely when thin.
        if (items.length < 2) return;
      } else if (!merge && !smartUsed && items.length < MIN_RELEVANT) {
        items = items.concat(shuffle(t3).slice(0, MIN_RELEVANT - items.length));
      }
      items = items.filter(function (it) { return !SHOWN[it.id]; });
      if ((layout === 'compact' || root.dataset.strict === 'true') && items.length < 2) return;
      // v7.1: on the product page the strip under the form takes the first
      // picks, so the merged row keeps its own count on top of them
      var stripRoom = 0;
      if (merge) {
        var stripEl = document.querySelector('[data-rr-strip]');
        if (stripEl && !stripEl.__rrFilled) stripRoom = parseInt(stripEl.dataset.max, 10) || 3;
      }
      items = items.slice(0, maxItems + stripRoom);
      if (!items.length) return;
      items.forEach(function (it) { SHOWN[it.id] = true; });

      var smartShown = items.filter(function (it) { return it.src === 'smart'; }).length;
      var evVariant = smartUsed ? (smartShown >= 4 ? 'smart' : (smartShown ? 'mixed' : 'fallback'))
        : (AB === 'control' ? 'control' : 'fallback');
      var evBase = function (k, extra) {
        var e = { k: k, r: evRow, x: evVariant, s: evSeed };
        for (var key in extra) e[key] = extra[key];
        return e;
      };
      // v7.1 strip: the merged product page row gives its first picks to the
      // strip under the form; they count as positions 0 to n-1 of this row.
      var strip = merge ? document.querySelector('[data-rr-strip]') : null;
      var stripN = 0;
      if (strip && !strip.__rrFilled) {
        strip.__rrFilled = true;
        if (items.length >= 2) {
          stripN = Math.min(parseInt(strip.dataset.max, 10) || 3, items.length);
          buildStrip(strip, items.slice(0, stripN), function (k, item, pos) {
            if (evRow) rrEvent(evBase(k, { i: String(item.id), pos: pos, o: item.src }));
          });
        } else {
          stripGone(strip);
        }
      }
      items.forEach(function (item, pos) {
        if (pos < stripN) return;
        if (layout === 'compact') {
          var row = document.createElement('div');
          row.className = 'rr-pair';
          var rImg = document.createElement('img');
          rImg.className = 'rr-pair__img';
          rImg.loading = 'lazy';
          rImg.alt = item.title;
          rImg.src = squareImage(item.image) || '';
          row.appendChild(rImg);
          var info = document.createElement('div');
          info.className = 'rr-pair__info';
          var tl = document.createElement('a');
          tl.className = 'rr-pair__title';
          tl.href = item.url;
          tl.textContent = item.title;
          info.appendChild(tl);
          var pr = document.createElement('div');
          pr.className = 'rr-pair__price';
          pr.textContent = money(item.price);
          if (item.compareAt && item.compareAt > item.price) {
            var cm = document.createElement('span');
            cm.className = 'rr-pair__compare';
            cm.textContent = money(item.compareAt);
            pr.appendChild(cm);
          }
          info.appendChild(pr);
          row.appendChild(info);
          var addBtn = document.createElement('button');
          addBtn.type = 'button';
          addBtn.className = 'rr-pair__add';
          addBtn.textContent = 'Add';
          addBtn.addEventListener('click', function () {
            addBtn.disabled = true;
            addBtn.textContent = '…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.variantId, quantity: 1 })
            }).then(function (r) {
              if (!r.ok) throw new Error('add failed');
              addBtn.textContent = '✓';
              if (window.location.pathname.indexOf('/cart') === -1) {
                setTimeout(function () { window.location.href = '/cart'; }, 350);
              }
            }).catch(function () {
              addBtn.disabled = false;
              addBtn.textContent = 'Add';
            });
          });
          row.appendChild(addBtn);
          track.appendChild(row);
          return;
        }
        var onSale = !!(item.compareAt && item.compareAt > item.price);
        var card = document.createElement('div');
        card.className = 'rr-card' + (onSale ? ' rr-card--sale' : '');

        var link = document.createElement('a');
        link.className = 'rr-card__media';
        link.href = item.url;
        if (evRow) link.addEventListener('click', function () { rrEvent(evBase('click', { i: String(item.id), pos: pos, o: item.src })); });
        if (onSale) {
          // Sale label: first child of the image wrapper so it sits over the
          // top-left corner. Styled in sections/raptor-recs.liquid.
          var badge = document.createElement('span');
          badge.className = 'rr-card__badge';
          badge.textContent = 'Sale';
          link.appendChild(badge);
        }
        var img = document.createElement('img');
        img.className = 'rr-card__img';
        img.loading = 'lazy';
        img.alt = item.title;
        img.src = squareImage(item.image) || '';
        link.appendChild(img);
        card.appendChild(link);

        var titleLink = document.createElement('a');
        titleLink.className = 'rr-card__title';
        titleLink.href = item.url;
        if (evRow) titleLink.addEventListener('click', function () { rrEvent(evBase('click', { i: String(item.id), pos: pos, o: item.src })); });
        titleLink.textContent = item.title;
        card.appendChild(titleLink);

        if (showStars) {
          var stars = document.createElement('div');
          stars.className = 'rr-card__stars';
          stars.setAttribute('data-rr-handle', item.handle);
          card.appendChild(stars);
        }

        var price = document.createElement('div');
        price.className = 'rr-card__price';
        price.textContent = money(item.price);
        if (item.compareAt && item.compareAt > item.price) {
          var cmp = document.createElement('span');
          cmp.className = 'rr-card__compare';
          cmp.textContent = money(item.compareAt);
          price.appendChild(cmp);
        }
        card.appendChild(price);

        var qtyInput = null;
        if (showQty) {
          var qtyWrap = document.createElement('div');
          qtyWrap.className = 'rr-card__qty';
          var minus = document.createElement('button');
          minus.type = 'button'; minus.textContent = '−';
          minus.className = 'rr-card__qty-btn';
          minus.setAttribute('aria-label', 'Decrease quantity');
          qtyInput = document.createElement('input');
          qtyInput.type = 'text'; qtyInput.inputMode = 'numeric';
          qtyInput.value = '1';
          qtyInput.className = 'rr-card__qty-input';
          qtyInput.setAttribute('aria-label', 'Quantity');
          var plus = document.createElement('button');
          plus.type = 'button'; plus.textContent = '+';
          plus.className = 'rr-card__qty-btn';
          plus.setAttribute('aria-label', 'Increase quantity');
          minus.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
          });
          plus.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1));
          });
          qtyWrap.appendChild(minus); qtyWrap.appendChild(qtyInput); qtyWrap.appendChild(plus);
          card.appendChild(qtyWrap);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rr-card__add';
        /* v2.16 (spec 5.2/5.3): the label lives in span.text so the "✓ Added"
           flip (rr-motion.js, on gv:cart:added) can slide it away */
        var btnLabel = document.createElement('span');
        btnLabel.className = 'text';
        btnLabel.textContent = 'Add to cart';
        btn.appendChild(btnLabel);
        btn.addEventListener('click', function () {
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          btn.disabled = true;
          btnLabel.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.variantId, quantity: qty })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            if (evRow) rrEvent(evBase('add', { i: String(item.id), pos: pos, o: item.src }));
            btnLabel.textContent = 'Add to cart';
            try {
              document.dispatchEvent(new CustomEvent('gv:cart:added', { detail: { button: btn } }));
            } catch (e) { btnLabel.textContent = 'Added ✓'; }
            // Cart page: the cart__main /cart/add sniffer reloads and the ETA
            // machinery re-runs. Product/other pages: go to the cart once the
            // "✓ Added" flip has played (the add has already succeeded).
            if (window.location.pathname.indexOf('/cart') === -1) {
              /* v2.18 6L E3: stay on the page; the count pops and the button says Added */
              try { document.dispatchEvent(new CustomEvent('rr:recs:added')); } catch (e) { /* old browsers */ }
            }
          }).catch(function () {
            btn.disabled = false;
            btnLabel.textContent = 'Add to cart';
          });
        });
        card.appendChild(btn);

        track.appendChild(card);
      });

      if (items.length > stripN) root.style.display = 'block';

      if (evRow && items.length) {
        var evIds = items.map(function (it) { return String(it.id); });
        var evSrc = items.map(function (it) { return it.src; });
        var sendView = function () { rrEvent(evBase('rowview', { i: evIds, io: evSrc })); };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); sendView(); }
          }, { threshold: 0.4 });
          if (items.length > stripN) io.observe(root);
          if (stripN) io.observe(strip);
        } else {
          sendView();
        }
      }

      // Compact rotator: one row visible at a time, arrows cycle (wrap).
      if (layout === 'compact') {
        var rows = [].slice.call(track.querySelectorAll('.rr-pair'));
        var nav = root.querySelector('.rr-pairs__nav');
        if (rows.length > 1 && nav) {
          var active = 0;
          function showRow(i) {
            active = (i + rows.length) % rows.length;
            rows.forEach(function (r2, k) {
              if (k === active) r2.classList.remove('rr-pair--hidden');
              else r2.classList.add('rr-pair--hidden');
            });
          }
          nav.style.display = '';
          var prevB = nav.querySelector('[data-rr-prev]');
          var nextB = nav.querySelector('[data-rr-next]');
          if (prevB) prevB.addEventListener('click', function () { showRow(active - 1); });
          if (nextB) nextB.addEventListener('click', function () { showRow(active + 1); });
          showRow(0);
        }
      }

      // Review stars (v7.2, 5 Oct 2026): drawn here from each product's
      // rating, read from templates/product.rr-rating-endpoint.liquid and kept
      // in localStorage for a day, once the strip comes near the screen.
      // Replaces Judge.me's batchRenderBadges and the core script it pulled
      // in. Most products have no reviews, so most cards stay empty.
      if (showStars) {
        var holders = [].slice.call(root.querySelectorAll('.rr-card__stars[data-rr-handle]'));
        var drawStars = function () {
          holders.forEach(function (el) {
            rrRating(el.getAttribute('data-rr-handle')).then(function (d) {
              if (!d || !(d.n > 0) || !(d.r > 0)) return;
              var r = Math.min(5, d.r);
              el.innerHTML = '<span class="rr-stars" role="img" aria-label="' + (Math.round(r * 10) / 10) +
                ' out of 5 stars" style="--rr-fill:' + (Math.round(r * 200) / 10) + '%"></span>' +
                '<span class="rr-card__stars-n">' + d.n + (d.n === 1 ? ' review' : ' reviews') + '</span>';
            });
          });
        };
        if (holders.length) {
          if ('IntersectionObserver' in window) {
            var starIO = new IntersectionObserver(function (en) {
              if (!en.some(function (x) { return x.isIntersecting; })) return;
              starIO.disconnect();
              drawStars();
            }, { rootMargin: '600px 0px' });
            starIO.observe(root);
          } else {
            drawStars();
          }
        }
      }

      var prev = root.querySelector('.rr-recs__arrow--prev');
      var next = root.querySelector('.rr-recs__arrow--next');
      function step() {
        var card = track.querySelector('.rr-card');
        return card ? card.getBoundingClientRect().width + 14 : 240;
      }
      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: ((window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth') }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: ((window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth') }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-raptor-recs]').forEach(init);
    var strip = document.querySelector('[data-rr-strip]');
    if (strip) {
      if (!document.querySelector('[data-raptor-recs][data-merge="true"]')) stripGone(strip);
      else setTimeout(function () { if (strip.classList.contains('is-pending')) stripGone(strip); }, 12000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
